const PRICES_URL = '/api/prices.php';
const LOGIN_URL = '/api/login.php';
const LOGOUT_URL = '/api/logout.php';
const ME_URL = '/api/me.php';

const parseJson = async (response) => {
  const text = await response.text();
  if (!text) {
    return {};
  }
  try {
    return JSON.parse(text);
  } catch (error) {
    throw new Error('Invalid server response.');
  }
};

export const fetchPriceOverrides = async () => {
  const response = await fetch(PRICES_URL, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Unable to load price overrides.');
  }

  const payload = await parseJson(response);
  return payload.overrides || {};
};

export const savePriceOverridesApi = async (overrides, expectedOverrides) => {
  const response = await fetch(PRICES_URL, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ overrides, expectedOverrides }),
  });

  if (response.status === 401) {
    const err = new Error('Not authenticated.');
    err.code = 'UNAUTHORIZED';
    throw err;
  }

  if (!response.ok) {
    const err = new Error(response.status === 409 ? 'The menu changed in another session. Your draft is kept; review it before saving again.' : 'Unable to save. Your staged changes are kept. Try again.');
    if (response.status === 409) err.code = 'CONFLICT';
    throw err;
  }

  return parseJson(response);
};

export const loginApi = async (password) => {
  const response = await fetch(LOGIN_URL, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password }),
  });

  if (response.status === 401) {
    const err = new Error('Invalid password.');
    err.code = 'INVALID_PASSWORD';
    throw err;
  }

  if (!response.ok) {
    const data = await parseJson(response).catch(() => ({}));
    throw new Error(data.error || 'Login failed.');
  }

  return parseJson(response);
};

export const logoutApi = async () => {
  const response = await fetch(LOGOUT_URL, {
    method: 'POST',
    credentials: 'include',
  });
  if (!response.ok) throw new Error('Could not sign out. Please try again.');
};

export const checkAuthApi = async () => {
  try {
    const response = await fetch(ME_URL, {
      method: 'GET',
      credentials: 'include',
    });
    if (!response.ok) {
      return false;
    }
    const payload = await parseJson(response);
    return Boolean(payload.authenticated);
  } catch (error) {
    return false;
  }
};
